(function ($) {
  /**
   * initializeBlock
   *
   * Adds custom JavaScript to the block HTML.
   *
   */

  const initializeBlock = function () {
    if ($(".map").length) {
      initMap($(".map"));
    }
  };

  // Initialize each block on page load (front end).
  $(document).ready(function () {
    initializeBlock();
  });

  function initMap($el) {
    // Find marker elements within map.
    var $markers = $el.find(".marker");

    // Create gerenic map.
    var mapArgs = {
      zoom: $el.data("zoom") || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      styles: [
        {
          featureType: "all",
          elementType: "labels.text.fill",
          stylers: [
            {
              saturation: 36,
            },
            {
              color: "#000000",
            },
            {
              lightness: 40,
            },
          ],
        },
        {
          featureType: "all",
          elementType: "labels.text.stroke",
          stylers: [
            {
              visibility: "on",
            },
            {
              color: "#000000",
            },
            {
              lightness: 16,
            },
          ],
        },
        {
          featureType: "all",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#000000",
            },
            {
              lightness: "0",
            },
            {
              gamma: "1",
            },
          ],
        },
        {
          featureType: "administrative",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#000000",
            },
            {
              lightness: "0",
            },
            {
              weight: 1.2,
            },
          ],
        },
        {
          featureType: "administrative",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.country",
          elementType: "all",
          stylers: [
            {
              visibility: "simplified",
            },
          ],
        },
        {
          featureType: "administrative.country",
          elementType: "geometry",
          stylers: [
            {
              visibility: "simplified",
            },
          ],
        },
        {
          featureType: "administrative.country",
          elementType: "labels.text",
          stylers: [
            {
              visibility: "simplified",
            },
          ],
        },
        {
          featureType: "administrative.province",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.locality",
          elementType: "all",
          stylers: [
            {
              visibility: "simplified",
            },
            {
              saturation: "-100",
            },
            {
              lightness: "30",
            },
          ],
        },
        {
          featureType: "administrative.neighborhood",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.land_parcel",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "all",
          stylers: [
            {
              visibility: "simplified",
            },
            {
              gamma: "0.00",
            },
            {
              lightness: "74",
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "geometry",
          stylers: [
            {
              color: "#181818",
            },
            {
              lightness: "0",
            },
            {
              gamma: "1",
            },
          ],
        },
        {
          featureType: "landscape.man_made",
          elementType: "all",
          stylers: [
            {
              lightness: "3",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [
            {
              color: "#000000",
            },
            {
              lightness: "0",
            },
            {
              gamma: "1",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [
            {
              visibility: "simplified",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#3b3b3b",
            },
            {
              lightness: "0",
            },
            {
              gamma: "1",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#3b3b3b",
            },
            {
              lightness: "0",
            },
            {
              weight: 0.2,
            },
            {
              gamma: "1",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "geometry",
          stylers: [
            {
              color: "#3b3b3b",
            },
            {
              lightness: "0",
            },
            {
              gamma: "1",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "geometry",
          stylers: [
            {
              color: "#3b3b3b",
            },
            {
              lightness: "0",
            },
            {
              gamma: "1",
            },
          ],
        },
        {
          featureType: "transit",
          elementType: "geometry",
          stylers: [
            {
              color: "#000000",
            },
            {
              lightness: 19,
            },
          ],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              color: "#000000",
            },
            {
              lightness: 17,
            },
          ],
        },
      ],
    };
    var map = new google.maps.Map($el[0], mapArgs);

    // Add markers.
    map.markers = [];
    $markers.each(function () {
      initMarker($(this), map);
    });

    // Center map based on markers.
    centerMap(map);

    // Return map instance.
    return map;
  }

  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  function initMarker($marker, map) {
    // Get position from marker.
    var lat = $marker.data("lat");
    var lng = $marker.data("lng");
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    var icon = {
      path: "M4.85781 4.70749C7.68037 1.88493 11.5086 0.299225 15.5003 0.299225C19.492 0.299225 23.3202 1.88493 26.1428 4.70749C28.9654 7.53006 30.5511 11.3583 30.5511 15.35C30.5511 19.3417 28.9654 23.1699 26.1428 25.9925L15.5003 36.635L4.85781 25.9925C3.46012 24.595 2.35141 22.9358 1.59498 21.1097C0.838549 19.2837 0.449219 17.3265 0.449219 15.35C0.449219 13.3735 0.838549 11.4163 1.59498 9.59025C2.35141 7.7642 3.46012 6.10504 4.85781 4.70749V4.70749ZM15.5003 19.65C16.6407 19.65 17.7345 19.197 18.5409 18.3906C19.3473 17.5841 19.8003 16.4904 19.8003 15.35C19.8003 14.2096 19.3473 13.1158 18.5409 12.3094C17.7345 11.503 16.6407 11.05 15.5003 11.05C14.3599 11.05 13.2662 11.503 12.4597 12.3094C11.6533 13.1158 11.2003 14.2096 11.2003 15.35C11.2003 16.4904 11.6533 17.5841 12.4597 18.3906C13.2662 19.197 14.3599 19.65 15.5003 19.65Z",
      fillColor: "#ECC12B",
      fillOpacity: 1,
      anchor: new google.maps.Point(15, 36),
      strokeWeight: 0,
      scale: 1,
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
      position: latLng,
      map: map,
      icon: icon,
    });

    // Append to reference for later use.
    map.markers.push(marker);

    // If marker contains HTML, add it to an infoWindow.
    if ($marker.html()) {
      // Create info window.
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      });

      // Show info window when marker is clicked.
      google.maps.event.addListener(marker, "click", function () {
        infowindow.open(map, marker);
      });
    }
  }

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMap(map) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng(),
      });
    });

    // Case: Single marker.
    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());

      // Case: Multiple markers.
    } else {
      map.fitBounds(bounds);
    }
  }

  // // Initialize dynamic block preview (editor).
  // if( window.acf ) {
  //     window.acf.addAction('render_block_preview/type=program', initializeBlock)
  // }
})(jQuery);
